var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"document-nopad"},[_c('iframe',{staticClass:"faq-iframe",attrs:{"src":_vm.gravBaseUrl + 'faq-06-application',"width":"100%","height":"640px","frameBorder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }